import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  Table,
  FormText,
  Button,
  FormInput,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';

import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { compareNumber } from '@app/helpers/comparators';

import { CrfResumoAnoMes, CrfValorTotalAno } from '@app/api/crf/crfProjeto';

interface FormResumoAnoMesProjetoProps {
  resultTableAnoMes: CrfResumoAnoMes;
  resumoAno: CrfResumoAnoMes[];
}

const { Panel } = Collapse;

const FormTableOrcadoAnoProjeto = ({ resumoAno, resultTableAnoMes }: FormResumoAnoMesProjetoProps) => {
  const [resumoHeader, setResumoHeader] = useState<string>();
  const [planilhaId, setPlanilhaId] = useState<string>();
  const [valoresTotaisPorAno, setValoresTotaisPorAno] = useState<CrfValorTotalAno[]>();

  useEffect(() => {
    const getData = async () => {
      if (resultTableAnoMes && resultTableAnoMes.dataAprovacao) {
        let header =
          resultTableAnoMes.numero + ' - ' + resultTableAnoMes.revisao + ' - ' + resultTableAnoMes.dataAprovacao;
        setResumoHeader(header);
        setPlanilhaId(resultTableAnoMes.planilhaId);
        setValoresTotaisPorAno(resultTableAnoMes.valorTotalCurrencyArray);
      }
    };

    getData();
  }, [resumoAno]);

  const columns = () => {
    const colluns = [];

    let col = [];

    colluns.push(
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Centro de Custo',
        dataIndex: 'numeroCentroDeCusto',
        width: '3%',
        ...mountFormFilterDropDown("numeroCentroDeCusto", "Pesquisar por centro de custo"),
        sorter: (a: any, b: any) => compareNumber(a.numeroCentroDeCusto, b.numeroCentroDeCusto),
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'crfContaContabilCodigo',
        width: '3%',
        ...mountFormFilterDropDown("crfContaContabilCodigo", "Pesquisar por conta contábil"),
        sorter: (a: any, b: any) => compareNumber(a.crfContaContabilCodigo, b.crfContaContabilCodigo),
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
      }
    );

    if (valoresTotaisPorAno && valoresTotaisPorAno.length > 0) {
      for (const element of valoresTotaisPorAno) {
        colluns.push({
          title: `${element.ano}`,
          dataIndex: `${element.ano}`,
          width: '',
          children: [
            {
              title: `${element.valorTotalCurrency}`,
              dataIndex: `${element.ano}`,
            },
          ],
        });
      }
    }

    return colluns;
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo orçado Ano" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                planilhaId && (
                  <Button
                    title="CONSULTAR DISTRIBUIÇÃO DO ANO ATUAL"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/Cr/moduloOrcado/economicoAnoMes/detail/${planilhaId}`;
                    }}
                  />
                ),
              ]}>
              {resumoHeader && (
                <>
                  <Row>
                    <FormInput
                      label="Planilha ciclo orçamentário Atual"
                      name="numero"
                      value={resumoHeader || ''}
                      span={3}
                      disabled
                    />
                  </Row>
                  <br />
                  <Row>
                    <Table className="tabelaOrcado" rowKey="index" columns={columns()} dataSource={resumoAno || []} />
                  </Row>
                </>
              )}
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableOrcadoAnoProjeto;
